import React from "react";
import styled from "styled-components";
import useFetch from "react-fetch-hook";

import Box from "../Box/Box";
import Icon from "../Icon/Icon";
import { buildSocialMedia } from "./SocialMediaBuilder";
import { LinkProps } from "./BCAFooter";

export interface SocialMediaProps {
	socialMediaUrl: string;
}

export interface SocialMediaLinksProps {
	twitter: LinkProps;
	linkedIn: LinkProps;
}

const Anchor = styled.a`
	display: inline-block;
`;

export default function SocialMedia({ socialMediaUrl }: SocialMediaProps) {
	const { data } = useFetch(socialMediaUrl);
	const socialMedia = buildSocialMedia(data);

	return (
		<Box
			data-testid="social-media-section"
			display="flex"
			justifyContent={["center", "flex-end"]}
		>
			<Anchor
				href={socialMedia.twitter.link}
				target={socialMedia.twitter.openInNewWindow ? "_blank" : "_top"}
				rel="noopener noreferrer"
				aria-label="Twitter"
			>
				<Icon
					name="twitter"
					color="primary-white"
					mr={6}
					width={16}
					height={16}
				/>
			</Anchor>
			<Anchor
				href={socialMedia.linkedIn.link}
				target={socialMedia.linkedIn.openInNewWindow ? "_blank" : "_top"}
				rel="noopener noreferrer"
				aria-label="LinkedIn"
			>
				<Icon name="linkedin-in" color="primary-white" width={15} height={15} />
			</Anchor>
		</Box>
	);
}
